import { create } from 'zustand';

export interface WalkthroughStep {
  id: string;
  subtopicoId: string;
  ordem: number;
  tipoAcao: string;
  selectorCss: string;
  valor?: string;
  /** Texto no card (pode ser mais longo / premium) */
  legenda: string;
  /** Script falado (TTS / speechSynthesis); se vazio, usa legenda */
  legendaFalada?: string | null;
  urlAtual: string;
  audioUrl?: string | null;
  screenshotUrl?: string | null;
  subtopicoTitulo?: string;
}

export interface WalkthroughState {
  steps: WalkthroughStep[];
  isActive: boolean;
  currentStepIndex: number;
  /** Resenha da página (contexto / passo 0) */
  pageResenha?: string | null;
  startWalkthrough: (
    steps: WalkthroughStep[],
    opts?: { pageResenha?: string | null },
  ) => void;
  stopWalkthrough: () => void;
  nextStep: () => void;
  prevStep: () => void;
  setCurrentStepIndex: (index: number) => void;
}

export const useWalkthroughStore = create<WalkthroughState>((set) => ({
  steps: [],
  isActive: false,
  currentStepIndex: 0,
  pageResenha: null,
  startWalkthrough: (steps, opts) =>
    set({
      steps,
      isActive: true,
      currentStepIndex: 0,
      pageResenha: opts?.pageResenha ?? null,
    }),
  stopWalkthrough: () =>
    set({
      steps: [],
      isActive: false,
      currentStepIndex: 0,
      pageResenha: null,
    }),
  nextStep: () =>
    set((state) => ({
      currentStepIndex: Math.min(
        state.currentStepIndex + 1,
        state.steps.length - 1,
      ),
    })),
  prevStep: () =>
    set((state) => ({
      currentStepIndex: Math.max(state.currentStepIndex - 1, 0),
    })),
  setCurrentStepIndex: (index) =>
    set((state) => ({
      currentStepIndex: Math.max(
        0,
        Math.min(index, state.steps.length - 1),
      ),
    })),
}));
